<template>
  <div
    class="zoox-component zoox-tab-menu"
    :style="{
      'grid-template-columns': `repeat(${menuOptions.length}, minmax(50px, 1fr))`,
      absolute: absolute,
    }"
  >
    <div
      v-for="(option, index) of menuOptions"
      :key="index"
      class="menu-option"
      @click="onClickOption(option)"
    >
      <z-icon
        class="icon"
        size="24px"
        color="var(--white)"
        :class="{'is-active': option.isActive}"
        >{{ option.icon }}</z-icon
      >
      <div class="menu-option-title">
        {{ option.title }}
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @displayName Tab Menu
 */
export default {
  name: 'ZTabMenu',
  props: {
    menuOptions: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onClickOption(option) {
      this.$emit('click', option)
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-tab-menu {
  background: var(--primary);
  height: 55px;
  width: 100%;
  border-radius: var(--component-card-radius) var(--component-card-radius) 0 0;

  display: grid;
  padding-top: 5px;

  .icon {
    margin-bottom: 1px;

    &.is-active {
      background-color: var(--white);
      color: var(--primary) !important;
      padding: 0px 6px;
      border-radius: 4px;
    }
  }

  .menu-option {
    height: 100%;
    font-size: 0.625rem;
    color: var(--white);
    display: grid;
    justify-items: center;

    &:hover {
      opacity: 0.8;
    }

    .menu-option-title {
      text-align: center;
      align-self: start;
    }
  }
}
</style>
